import { render, staticRenderFns } from "./PestDetailsContainer.vue?vue&type=template&id=37f7c2d5&lang=html&"
import script from "./PestDetailsContainer.vue?vue&type=script&lang=ts&"
export * from "./PestDetailsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports